import {useMsal} from '@azure/msal-react';
import {useEffect, useState} from 'react';
import {isDevBypassEnabled} from 'src/app/constants/config/devBypassConfig';
import {initApis} from 'src/data/api/api';

export const useInitApis = () => {
    const [isApiConfigured, setIsApiConfigured] = useState(false);
    const {accounts, instance} = useMsal();

    useEffect(() => {
        if (isDevBypassEnabled) {
            initApis();
            setIsApiConfigured(true);
            return;
        }

        if (accounts.length === 0) return;

        instance.setActiveAccount(accounts[0]);
        const token = accounts[0].idToken;

        if (!token) return;

        initApis();
        setIsApiConfigured(true);
    }, [instance, accounts]);

    return isApiConfigured;
};
